module.exports = __webpack_public_path__ + "static/media/AB_L31_9.0a9f9370.jpg";